import { render, staticRenderFns } from "./SfCircleIcon.vue?vue&type=template&id=d040bf4e&functional=true&"
import script from "./SfCircleIcon.vue?vue&type=script&lang=js&"
export * from "./SfCircleIcon.vue?vue&type=script&lang=js&"
import style0 from "./SfCircleIcon.vue?vue&type=style&index=0&id=d040bf4e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports